// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../../../css-loader/0.17.0/css-loader/index.js!./../../../less-loader/2.2.3/less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!./../../../style-loader/0.12.4/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!./../../../css-loader/0.17.0/css-loader/index.js!./../../../less-loader/2.2.3/less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js", function() {
			var newContent = require("!!./../../../css-loader/0.17.0/css-loader/index.js!./../../../less-loader/2.2.3/less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/style-loader/0.12.4/style-loader!./~/.npminstall/css-loader/0.17.0/css-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./~/.npminstall/font-awesome-webpack/0.0.4/font-awesome-webpack/font-awesome-styles.loader.js!./~/.npminstall/font-awesome-webpack/0.0.4/font-awesome-webpack/font-awesome.config.js
 ** module id = 658
 ** module chunks = 0
 **/